module.exports = __webpack_public_path__ + "img/dark.af99262f.svg";